import { Outlet, createFileRoute } from "@tanstack/react-router";

import { APP_ROUTES_TO } from "@/utils/routes";

export const Route = createFileRoute("/events/$id/bookings")({
    component: RouteComponent,
    staticData: {
        config: {
            breadcrumb: {
                title: "event_bookings",
                to: APP_ROUTES_TO.EVENT_BOOKINGS,
            },
            title: "event_bookings",
        },
    },
});

function RouteComponent() {
    return <Outlet />;
}
